import { Command } from 'commands/Commands';

export class ChangeMemberUrl extends Command {
  type: string = 'Member.ChangeMemberUrl';
  priority = 100;
}
